// Module
var code = `<div class="HOA-misc-guidedSteps__header">
    <div class="HOA-misc-guidedSteps__header-text">Shopping Cart</div>
</div>
<div class="HOA-propertyblock-flextable u-pT10 u-pB10">
    <div *ngIf="cartItems.length <= 0"
         class="HOA-propertyblock-flextable__cell
                        HOA-propertyblock-flextable__cell--list
                        HOA-propertyblock-flextable__cell--100
                        HOA-propertyblock-flextable--truncate">
        <div class="HOA-propertyblock-flextable__cell-value HOA-propertyblock-flextable--truncate"
             tid="emptyCart">
            Your shopping cart is empty.
        </div>
    </div>
    <ng-container *ngFor="let cartItem of cartItems">
        <div class="HOA-propertyblock-flextable__cell
                            HOA-propertyblock-flextable__cell--list
                            HOA-propertyblock-flextable__cell--40
                            HOA-propertyblock-flextable--truncate">
            <div class="HOA-propertyblock-flextable__cell-value-darker HOA-propertyblock-flextable--truncate"
                 tid="description">
                {{ cartItem.description }}
            </div>
        </div>
        <div class="HOA-propertyblock-flextable__cell
                            HOA-propertyblock-flextable__cell--list
                            HOA-propertyblock-flextable__cell--20
                            HOA-propertyblock-flextable--truncate">
            <div class="HOA-propertyblock-flextable__cell-value-darker HOA-propertyblock-flextable--truncate"
                 tid="amount">
                {{ cartItem.amount | currency:"\$" }}
            </div>
        </div>
        <div class="HOA-propertyblock-flextable__cell
                            HOA-propertyblock-flextable__cell--list
                            HOA-propertyblock-flextable__cell--25
                            HOA-propertyblock-flextable--truncate">
            <div [ngClass]="{ 'is-invalid': cartItem.qtyError }"
                 class="Field HOA-propertyblock-flextable__cell-value-no-margin HOA-propertyblock-flextable--truncate u-mB2 u-pB0"
                 tid="qty">
                <button class="Button--teal Button--small" (click)="decrementQty(cartItem)">-</button>
                <input id="{{ cartItem.entityId }}-qty"
                       name="{{ cartItem.entityId }}-qty"
                       type="number"
                       class="Input qty-input"
                       [(ngModel)]="cartItem.qty"
                       min="1"
                       max="9999"
                       allow-pattern="\\d"
                       (change)="updateTotal();amenityService.validateCartItem(cartItem);onCartItemUpdate.emit()">
                <button class="Button--teal Button--small" (click)="incrementQty(cartItem)">+</button>
                <div class="Field-error u-textCenter"
                     id="{{ cartItem.entityId }}-qty-error">{{ cartItem.qtyError }}</div>
            </div>
        </div>
        <div class="HOA-propertyblock-flextable__cell
                            HOA-propertyblock-flextable__cell--list
                            HOA-propertyblock-flextable__cell--15
                            HOA-propertyblock-flextable--truncate">
            <div class="HOA-propertyblock-flextable__cell-value u-margin-right-align">
                <button type="button" (click)="deleteCartItem(cartItem)"
                        class="payment-history-payment-method-code-label Button--link HOA-payment-history-button"
                        tid="delete"> Delete
                </button>
            </div>
        </div>
        <div *ngIf="cartItem.displayNotes"
             class="HOA-propertyblock-flextable__cell
                            HOA-propertyblock-flextable__cell--list
                            HOA-propertyblock-flextable__cell--100">
            <div class="HOA-propertyblock-flextable__cell-value u-pL3" tid="displayNotes">
                {{ cartItem.displayNotes }}
            </div>
        </div>
        <div class="HOA-propertyblock-flextable__cell
                            HOA-propertyblock-flextable__cell--list
                            HOA-propertyblock-flextable__cell--100">
            <div class="HOA-propertyblock-flextable__cell-value u-pL3" tid="payerNotes">
                <button type="button" (click)="addEditNote(cartItem)"
                        class="payment-history-payment-method-code-label Button--link"
                        tid="addNote">
                    {{ cartItem.payerNotes ? 'Edit Note' : 'Add Note'}}
                </button>
            </div>
        </div>
    </ng-container>
</div>
`;
// Exports
module.exports = code;